import React, { useState } from "react";

import { useLocation } from "react-router-dom";
import { useLoading } from "../../../context/LoadingContext";
import ProjectForm from "./tabs/forms/ProjectForm";
import TeamMember from "./tabs/TeamMember";
import ProjectActivitie from "./tabs/ProjectActivitie";
import { useManageClientContext } from "../../../context/ManageClientContex";

const TabNames: string[] = [
  "General Information",
  "Team Members",
  "Project Activities",
];

const UpdateClientProjectPage: React.FC = () => {
  const location = useLocation();
  const { projectDetail, getProjectDetails } = useManageClientContext();

  const { isLoading } = useLoading();

  const state = location.state as
    | {
        id: number;
        activeTab?: string; // ?? Read activeTab from state
      }
    | undefined;

  const projectID = state?.id;
  const initialTab = state?.activeTab ?? "General Information"; // ?? Use activeTab from state or default

  const [activeTab, setActiveTab] = useState<string>(initialTab);

  React.useEffect(() => {
    getProjectDetails(Number(projectID));
  }, []);

  // ? HELPER FUNCTION: Check if project is closed (end_ts < today)
  const isProjectClosed = (): boolean => {
    if (!projectDetail?.end_ts) return false;
    const endDate = new Date(projectDetail.end_ts);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    endDate.setHours(0, 0, 0, 0);
    return endDate < today;
  };

  if (isLoading) {
    return <div>Loading...</div>;
  }

  const handleTabClick = (tab: string) => {
    setActiveTab(tab);
  };

  return (
    <div>
      <div className="mb-4 border-b border-gray-200 dark:border-gray-700">
        <ul
          className="flex flex-wrap -mb-px text-sm font-medium text-center"
          id="default-tab"
          data-tabs-toggle="#default-tab-content"
          role="tablist"
        >
          {/* ? TAB REMAINS CLICKABLE - No disable state */}
          {TabNames.map((item) => (
            <li key={item} className="me-2" role="presentation">
              <button
                className={`inline-block p-4 border-b-2 rounded-t-lg ${
                  activeTab === item
                    ? "border-blue-600 text-blue-600"
                    : "dark:border-gray-600"
                }`}
                id={item + `-tab`}
                data-tabs-target={`#` + item}
                type="button"
                role="tab"
                aria-controls={item}
                aria-selected={activeTab === item}
                onClick={() => handleTabClick(item)}
              >
                {item}
              </button>
            </li>
          ))}
        </ul>
      </div>
      <div id="default-tab-content">
        {TabNames.map((item) => (
          <div
            key={item}
            className={`p-4 rounded-lg bg-white dark:bg-gray-800 ${activeTab === item ? "block" : "hidden"}`}
            id={item}
            role="tabpanel"
            aria-labelledby={item + "-tab"}
          >
            {activeTab === "General Information" && <ProjectForm />}
            {activeTab === "Team Members" && (
              <TeamMember details={projectDetail} />
            )}
            {/* ? PASS isProjectClosed prop to ProjectActivitie */}
            {activeTab === "Project Activities" && (
              <ProjectActivitie isProjectClosed={isProjectClosed()} />
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default UpdateClientProjectPage;
